import {
  CANCEL_FUELING_PROCESS,
  CANCEL_FUELING_PROCESS_FAILED,
  HIDE_FUELING_PROCESS_CANCEL_EDIT,
  SHOW_FUELING_PROCESS_CANCEL_EDIT,
} from "./constants";
import FuelingProcessCancelEditState from "./state";

const fuelingProcessCancelEditInitialState: FuelingProcessCancelEditState = {
  fuelingProcessId: null,
  isModalVisible: false,
  isSaving: false,
  saveErrorCode: null,
  saveErrorMessage: null,
};

export const fuelingProcessCancelEditReducer = (
  state: FuelingProcessCancelEditState = fuelingProcessCancelEditInitialState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: any
): FuelingProcessCancelEditState => {
  switch (action.type) {
    case SHOW_FUELING_PROCESS_CANCEL_EDIT:
      return {
        ...state,
        fuelingProcessId: action.fuelingProcessId,
        isModalVisible: true,
      };

    case HIDE_FUELING_PROCESS_CANCEL_EDIT:
      return fuelingProcessCancelEditInitialState;

    case CANCEL_FUELING_PROCESS:
      return {
        ...state,
        isSaving: true,
        saveErrorCode: null,
        saveErrorMessage: null,
      };

    case CANCEL_FUELING_PROCESS_FAILED:
      return {
        ...state,
        isSaving: false,
        saveErrorCode: action.errorCode,
        saveErrorMessage: action.errorMessage,
      };
  }

  return state;
};
